module.exports = __webpack_public_path__ + "img/arrow-up-a-z.def99535.svg";